"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Contract = require("@tableau/api-external-contract-js");
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const api_internal_contract_js_1 = require("@tableau/api-internal-contract-js");
const api_shared_js_1 = require("@tableau/api-shared-js");
const TableauEvent_1 = require("../Events/TableauEvent");
const ServiceRegistryUtil_1 = require("../Services/ServiceRegistryUtil");
class DialogMessageEvent extends TableauEvent_1.TableauEvent {
    constructor(message) {
        super(Contract.TableauEventType.DialogMessageReceived);
        this.message = message;
    }
}
exports.DialogMessageEvent = DialogMessageEvent;
class UIImpl {
    constructor() { }
    displayDialogAsync(url, payload, options) {
        const uiService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("UIService" /* UIService */);
        const notificationService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("notification-service" /* Notification */);
        return new Promise((resolve, reject) => {
            uiService
                .displayDialogAsync(url, payload || '', options)
                .then(() => {
                const unregisterFn = notificationService.registerHandler(api_internal_contract_js_1.NotificationId.ExtensionDialogUpdate, () => {
                    // Let through any dialog update event
                    return true;
                }, (event) => {
                    if (event.isCloseEvent) {
                        if (event.closePayload === undefined) {
                            throw new api_shared_js_1.TableauError(Contract.ErrorCodes.InternalError, 'closePayload is undefined');
                        }
                        resolve(event.closePayload);
                    }
                    else {
                        reject(new api_shared_js_1.TableauError(api_external_contract_js_1.ErrorCodes.DialogClosedByUser, 'Extension dialog closed by user.'));
                    }
                    unregisterFn();
                });
            })
                .catch((error) => {
                reject(error);
            });
        });
    }
    sendDialogMessageAsync(message, targetDialogUrl) {
        const uiService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("UIService" /* UIService */);
        uiService.sendDialogMessageAsync(message, targetDialogUrl);
    }
    closeDialog(payload) {
        const uiService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("UIService" /* UIService */);
        uiService.closeDialog(payload);
    }
    /**
     * Initializes all events relevant to UI object.
     *
     * @returns {Array<SingleEventManager>} Collection of event managers to pass to an EventListenerManager.
     */
    initializeEvents() {
        const results = new Array();
        let notificationService;
        try {
            notificationService = api_shared_js_1.ApiServiceRegistry.get(ServiceRegistryUtil_1.ExtensionsRegistryId).getService("notification-service" /* Notification */);
        }
        catch (e) {
            // If we don't have this service registered, just return
            return results;
        }
        const dialogMessageEvent = new api_shared_js_1.SingleEventManagerImpl(Contract.TableauEventType.DialogMessageReceived);
        notificationService.registerHandler(api_internal_contract_js_1.NotificationId.ExtensionDialogMessage, () => true, (event) => {
            dialogMessageEvent.triggerEvent(() => new DialogMessageEvent(event.message));
        });
        results.push(dialogMessageEvent);
        return results;
    }
}
exports.UIImpl = UIImpl;
//# sourceMappingURL=UIImpl.js.map